export default __webpack_public_path__ + "static/footer_logo_onlineStore_fr-28cce999-5df189eb10564ec68e5474dec86086d7.png";